import React from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TablePagination from '@mui/material/TablePagination';
import {ezprOrange} from './_helpers';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {PaginationActionsWithoutFirstAndLastPage} from './PaginationActionsWithoutFirstAndLastPage.jsx';

/**
 * @param {object} props
 * @return {JSX.Element}
 */
export function ListOfPREditorsPagination(props) {
    const {
        page,
        rowsPerPage,
        handleChangeRowsPerPage,
        handleChangePage,
        count,
        rowsPerPageOptions,
    } = props;

    return (
        <div className="list-of-pr-editors-pagination" translate="no">
            <div style={{display: 'flex', alignItems: 'center'}}>
                <label>Show Line:</label>
                <Select
                    IconComponent={ExpandMoreIcon}
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                    size="small"
                    sx={{
                        'fontSize': 14,
                        'boxShadow': 'none',
                        'minWidth': 80,
                        '.MuiSelect-select': {color: ezprOrange},
                        '.MuiOutlinedInput-notchedOutline': {border: 0},
                        '&:hover .MuiOutlinedInput-notchedOutline': {border: 0},
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {border: 0},
                    }}
                >
                    {rowsPerPageOptions.map((opt) => (
                        <MenuItem key={opt} value={opt} sx={{fontSize: 14}}>
                            {opt} / Page
                        </MenuItem>
                    ))}
                </Select>
            </div>

            <TablePagination
                component="div"
                count={count}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
                rowsPerPageOptions={[]}
                ActionsComponent={PaginationActionsWithoutFirstAndLastPage}
                labelDisplayedRows={() => ''}
                sx={{color: 'inherit'}}
            />
        </div>
    );
}

ListOfPREditorsPagination.propTypes = {
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    handleChangeRowsPerPage: PropTypes.func.isRequired,
    handleChangePage: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
};
